import { FC, Fragment } from 'react'
import styles from './PerfectNightSleep.module.scss'
import { PerfectNightSleepProps, CardProps } from './types'
import { useRootStore } from 'components/_hooks/useRootStore'
import { observer } from 'mobx-react'
import { Img } from 'components/basic/Img'

export const BestTempYetConnected = observer(() => {
	const { settingsStore } = useRootStore()
	return <PerfectNightSleep metric={settingsStore.metricRegion} />
})

const data = [
	{
		title: 'Biometric sensors',
		description: 'These algorithms take in data like chest vibrations, heart beats and respiration to determine health metrics and sleep stage.',
	},
	{
		title: 'Presence sensors',
		description: "These sensors detect presence so that Autopilot can determine if you're occupying your side of the Pod.",
	},
	{
		title: 'Environmental sensors',
		description: "These sensors detect your environmental temperature by sensing the room's temperature and humidity level.",
	},
]

export const PerfectNightSleep: FC<PerfectNightSleepProps> = (props) => {
	const { cards = data } = props
	return (
		<section className={`${styles.container} inner-paddings-y inner-paddings-x`}>
			<header className={styles.header}>
				<h2>A perfect night's sleep with Autopilot</h2>
				<p>The Pod provides Autopilot with the information it uses to get to know your sleep needs and monitor any changes in your environment that may disrupt your sleep.</p>
			</header>
			<div className={styles.inner}>
				<Img
					className={styles.image}
					src="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/perfect-night-sleep-autopilot-2024-big.png"
					alt="Beautiful bed"
					sources={[
						{
							src: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/perfect-night-sleep-autopilot-2024-big.png',
							mediaQuery: '(min-width: 600px)',
							dprHeight: 1080,
						},
						{
							src: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/perfect-night-sleep-autopilot-2024.png',
							mediaQuery: '(max-width: 1023px)',
							dprHeight: 1080,
						},
					]}
				/>
				<article>
					<ul className={styles.cards}>
						{cards.map((card) => (
							<Fragment key={card.title}>
								<Card {...card} />
							</Fragment>
						))}
					</ul>
				</article>
			</div>
		</section>
	)
}

const Card: FC<CardProps> = (props) => {
	const { title = '2x', description = 'Twice as powerful as the previous Pod generation.' } = props

	return (
		<li className={styles.card}>
			<h3>{title}</h3>
			<p>{description}</p>
		</li>
	)
}
